export default __webpack_public_path__ + "static/media/fireFN28.fe8aabd8.svg";